import { useState } from "react";
import { Settings } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { MobileNavigation } from "@/components/MobileNavigation";
import { ProfileHeader } from "@/components/profile/ProfileHeader";
import { ProfileMobileHeader } from "@/components/profile/ProfileMobileHeader";
import { ProfileTabs } from "@/components/profile/ProfileTabs";
import { ProfileEditDialog } from "@/components/profile/ProfileEditDialog";
import { PortfolioVisitsChart } from "@/components/profile/PortfolioVisitsChart";
import { useProfileData } from "@/hooks/useProfileData";

const Profile = () => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [isVisitorView, setIsVisitorView] = useState(false);
  const { id: profileId } = useParams();

  const {
    isOwnProfile,
    subscription,
    profile,
    isLoading,
    error,
    refetch,
  } = useProfileData(profileId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (error || !profile) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Profile not found</h2>
          <p className="text-muted-foreground">The requested profile could not be loaded.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto px-4 pt-20 sm:pt-24 pb-20 md:pb-6 space-y-6 max-w-7xl">
        <div className="md:hidden absolute top-4 right-4 z-50">
          <Link 
            to="/settings"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-background/80 backdrop-blur-sm border shadow-sm"
          >
            <Settings className="h-5 w-5" />
          </Link>
        </div>

        {/* Mobile view */}
        <div className="md:hidden">
          <ProfileMobileHeader
            profile={profile}
            subscription={subscription}
            isOwnProfile={isOwnProfile}
            isVisitorView={isVisitorView}
            setIsVisitorView={setIsVisitorView}
            setShowEditDialog={setShowEditDialog}
          />
        </div>

        {/* Desktop Profile Header */}
        <div className="hidden md:block border-b pb-10">
          <ProfileHeader
            profile={profile}
            subscription={subscription}
            isOwnProfile={isOwnProfile}
            isVisitorView={isVisitorView}
            setIsVisitorView={setIsVisitorView}
            setShowEditDialog={setShowEditDialog}
          />
        </div>

        {/* Portfolio Visits Chart */}
        {isOwnProfile && !isVisitorView && (
          <div className="hidden md:block">
            <PortfolioVisitsChart profileId={profile.id} />
          </div>
        )}

        {/* Projects Tabs */}
        <ProfileTabs
          profile={profile}
          isOwnProfile={isOwnProfile}
          isVisitorView={isVisitorView}
        />

        {/* Edit Profile Dialog */}
        {isOwnProfile && !isVisitorView && (
          <ProfileEditDialog
            open={showEditDialog}
            onOpenChange={setShowEditDialog}
            profile={profile}
            onUpdate={refetch}
          />
        )}
      </div>
      
      <MobileNavigation />
    </>
  );
};

export default Profile;